
const ApplicantClients_query = `
  query( $applicantId: Int!)
  {
    applicantClientList(applicantId: $applicantId)
    {      
      clientId
      name
      defaultClient
    }
  }    
`;

const getApplicantDataByUserEmail_query = `
  query( $email: String!)
  {
    getApplicantDataByUserEmail(email: $email)
    {      
      applicantId
      userId{
        username
      }
    }
  }    
`;


module.exports = {
  APPLICANT_CLIENTS_QUERY: ApplicantClients_query,
  GET_APPLICANT_DATA_BY_USER_EMAIL_QUERY: getApplicantDataByUserEmail_query,
};
